import { Node_Type } from 'ricos-schema';
import { t as toCamelCase_1 } from '../../../index-71a2067e.js';
import { WRAP, NO_WRAP } from '../../../consts.js';
import '../../../index-205daf5f.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const convertContainerData = (data, nodeType) => {
  if (!data.containerData) {
    return;
  }
  const { width, alignment, spoiler, height, textWrap = true } = data.containerData;
  const { enabled = false, description, buttonText } = spoiler != null ? spoiler : {};
  const config = __spreadProps(__spreadValues({}, data.config), {
    size: getSize(nodeType, width == null ? void 0 : width.size, width == null ? void 0 : width.custom),
    width: getWidth(nodeType, width == null ? void 0 : width.custom),
    height: (height == null ? void 0 : height.custom) && parseInt(height.custom),
    alignment: alignment == null ? void 0 : alignment.toLowerCase(),
    spoiler: spoiler && {
      enabled,
      description,
      buttonContent: buttonText
    },
    textWrap: textWrap ? WRAP : NO_WRAP
  });
  return config;
};
const getSize = (nodeType, size, customWidth) => {
  const hasCustomWidth = customWidth !== void 0;
  if ((nodeType === Node_Type.IMAGE || nodeType === Node_Type.BUTTON) && hasCustomWidth) {
    return "inline";
  }
  if (nodeType === Node_Type.BUTTON) {
    return "small";
  }
  if (nodeType === Node_Type.MAP) {
    return "content";
  }
  if (size) {
    return toCamelCase_1(size);
  }
};
const getWidth = (nodeType, width) => {
  if (width) {
    return parseInt(width);
  }
  if (!width && nodeType === Node_Type.BUTTON) {
    return "fit-content";
  }
};

export { convertContainerData };
//# sourceMappingURL=convertContainerData.js.map
